










































import Vue from 'vue';
import Component from 'vue-class-component';
import { Ref } from 'vue-property-decorator';
import { Department, departmentAdminApis } from '../../api';
import { ElTree, TreeData } from 'element-ui/types/tree';
import DepartmentEditDialog from './DepartmentEditDialog.vue';

interface Node extends TreeData {
  id: number;
  department: Department;
  children?: Node[];
}

@Component({ components: { DepartmentEditDialog } })
export default class DepartmentAdmin extends Vue {
  @Ref('tree') tree!: ElTree<number, Node>;
  @Ref('department-edit-dialog') departmentEditDialog!: DepartmentEditDialog;
  departments: Array<Department> | null = null;
  leafs: Set<number> = new Set([-1]);
  expandKeys: Array<number> = [-1];

  async load(parentId?: number) {
    const departments = await departmentAdminApis.getTree(parentId);
    const result = departments.map(department => {
      if (department.is_leaf) {
        this.leafs.add(department.id);
      }
      return { id: department.id, department } as Node;
    });
    this.expandKeys = Array.from(this.leafs);
    return result;
  }

  async loadNode(node: any, resolve: any) {
    if (node.data) {
      if (node.data.department.is_leaf) {
        resolve([]);
      } else {
        await this.load(node.data.id).then(resolve);
      }
    } else {
      await this.load().then(resolve);
    }
  }

  async createDepartment(parentNode: any, parent: Node) {
    const department = await this.departmentEditDialog.show({ parent_id: parent?.id } as Department);
    const node = { id: department.id, isLeaf: true, department } as Node;
    this.tree.append(node, parent);
    this.leafs.add(department.id);
    this.expandKeys = Array.from(this.leafs);
  }

  async editDepartment(d: Department) {
    const department = await this.departmentEditDialog.show(d);
    Object.assign(d, department);
  }

  async deleteDepartment(node: Node) {
    await departmentAdminApis.delete(node.id);
    this.$notify.success(`删除部门[${node.department.name}]成功`);
    this.tree.remove(node);
  }
}
